module.exports = __webpack_public_path__ + "static/enterprise-collaboration-5daf91ee846c4d22ff4f76b4e61f8b33.jpg";